import { productsFiltersVar } from 'modules/Products/store'
import { projectsFiltersVar } from 'modules/Projects/store'
import { usersFiltersVar } from 'modules/Users/store'
import { feedFiltersVar, shouldResetAllFiltersVar } from 'modulesCommon/store'

import {
  FEED_FILTER_INIT_VALUES,
  FEED_FILTER_STORAGE_NAME,
  PRODUCTS_FILTER_INIT_VALUES,
  PRODUCTS_FILTER_STORAGE_NAME,
  PROJECT_FILTER_INIT_VALUES,
  PROJECT_FILTER_STORAGE_NAME,
  USER_FILTER_INIT_VALUES,
  USERS_FILTER_STORAGE_NAME
} from 'shared/consts/filter'

import { formatFiltersParams, formatUserFiltersParams } from './filters'

export const resetAllFilters = () => {
  feedFiltersVar(formatFiltersParams(FEED_FILTER_INIT_VALUES))
  productsFiltersVar(formatFiltersParams(PRODUCTS_FILTER_INIT_VALUES))
  projectsFiltersVar(formatFiltersParams(PROJECT_FILTER_INIT_VALUES))
  usersFiltersVar(formatUserFiltersParams(USER_FILTER_INIT_VALUES))
  shouldResetAllFiltersVar(true)

  localStorage.setItem(FEED_FILTER_STORAGE_NAME, JSON.stringify(FEED_FILTER_INIT_VALUES))
  localStorage.setItem(PRODUCTS_FILTER_STORAGE_NAME, JSON.stringify(PRODUCTS_FILTER_INIT_VALUES))
  localStorage.setItem(PROJECT_FILTER_STORAGE_NAME, JSON.stringify(PROJECT_FILTER_INIT_VALUES))
  localStorage.setItem(USERS_FILTER_STORAGE_NAME, JSON.stringify(USER_FILTER_INIT_VALUES))
  localStorage.removeItem('space')
  localStorage.removeItem('label')
  localStorage.removeItem('labelTitle')
  localStorage.removeItem('labelCode')
}
